export default __webpack_public_path__ + "static/media/welcome_apoioaocliente.2368453b.png";